import { BpAnchor } from '../../../../shared/components/text/anchor/BpAnchor'
import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { Tag } from '../../../../lib/widgets/tags-editor/ui/Tag'

interface PageCellProps {
  title: string
  has_brand?: boolean
  url: string
}

export const PageCell = ({ title, has_brand, url }: PageCellProps) => {
  const { t } = useTranslation()

  return (
    <Fragment>
      <div className='flex items-center whitespace-nowrap'>
        <span className={'block max-w-xl overflow-hidden text-ellipsis font-medium'}>{title}</span>
      </div>
      <BpAnchor
        className={'mt-1 block w-96 overflow-hidden text-ellipsis'}
        href={url}
        target='_blank'
      >
        {url.split('?')[0]}
      </BpAnchor>
      {has_brand && (
        <div className={'pt-[2px]'}>
          <Tag>{t('components.tags.has_brand')}</Tag>
        </div>
      )}
    </Fragment>
  )
}
